// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_survey-header__qpZZD {
  background-color: #fff;
  height: 106px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  border-radius: 16px;
}

.styles_survey-title-container__6HP9A {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 50%;
}

.styles_survey-header-btn__0up2b {
  width: 42px !important;
  height: 42px !important;
  background-color: var(--orange) !important;
  color: var(--offRed) !important;
  padding: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_survey-header-input__OH\\+pO {
  width: 100% !important;
  font-weight: 700;
  font-size: 24px !important;
  line-height: 100%;
  border-bottom: 1px solid #000 !important;
  border-radius: 0px !important;
}

.styles_survey-header-info__DFDs9 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.styles_survey-header-info-item__\\+V2Lq {
  display: flex;
  flex-direction: column;
  color: var(--primary-color);
  gap: 4px;
  padding-right: 16px;
}

.styles_survey-header-info-item__\\+V2Lq span:first-child {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
}

.styles_survey-header-info-item__\\+V2Lq span:last-child {
  font-weight: 700;
  font-size: 25px;
  line-height: 100%;
}

.styles_survey-header-info-status__xMkks {
  background-color: var(--soft-blue);
  border: 1px solid var(--orange);
  border-radius: 30px;
  width: 158px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--primary-color);
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
}

.styles_survey-header-post__sTtb3 {
  border-radius: 30px;
  width: 158px;
  height: 42px;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
}

.styles_survey-content__52rnO {
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 24px;
  margin-top: 21px;
}

.styles_survey-navigation__j4GnH {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_survey-page-list__ABt2H {
  background-color: #fff;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.styles_survey-page-list-item__0VH6I {
  all: unset;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 8px;
  padding: 8px 16px;
}

.styles_survey-page-list-item__0VH6I:hover,
.styles_survey-page-list-item--active__D5Nw9 {
  background-color: var(--offRed);
  color: #000;
}

.styles_survey-page-list-item-title__TNh7I {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
}

.styles_survey-duration-header__rpGsQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.styles_survey-duration-header__rpGsQ h3 {
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
}

.styles_survey-duration-description__7i6pK {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  margin-bottom: 24px;
}

.styles_survey-cloud-item__K\\+QLL {
  display: flex;
  align-items: center;
  gap: 6px;
}

.styles_survey-cloud-item__K\\+QLL {
  margin-right: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SurveyLayout/styles/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EAEZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".survey-header {\n  background-color: #fff;\n  height: 106px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 32px;\n  border-radius: 16px;\n}\n\n.survey-title-container {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  width: 50%;\n}\n\n.survey-header-btn {\n  width: 42px !important;\n  height: 42px !important;\n  background-color: var(--orange) !important;\n  color: var(--offRed) !important;\n  padding: 0 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.survey-header-input {\n  width: 100% !important;\n  font-weight: 700;\n  font-size: 24px !important;\n  line-height: 100%;\n  border-bottom: 1px solid #000 !important;\n  border-radius: 0px !important;\n}\n\n.survey-header-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.survey-header-info-item {\n  display: flex;\n  flex-direction: column;\n  color: var(--primary-color);\n  gap: 4px;\n  padding-right: 16px;\n}\n\n.survey-header-info-item span:first-child {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n}\n\n.survey-header-info-item span:last-child {\n  font-weight: 700;\n  font-size: 25px;\n  line-height: 100%;\n}\n\n.survey-header-info-status {\n  background-color: var(--soft-blue);\n  border: 1px solid var(--orange);\n  border-radius: 30px;\n  width: 158px;\n  height: 42px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--primary-color);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n}\n\n.survey-header-post {\n  border-radius: 30px;\n  width: 158px;\n  height: 42px;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n}\n\n.survey-content {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n  gap: 24px;\n  margin-top: 21px;\n}\n\n.survey-navigation {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.survey-page-list {\n  background-color: #fff;\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.survey-page-list-item {\n  all: unset;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  border-radius: 8px;\n  padding: 8px 16px;\n}\n\n.survey-page-list-item:hover,\n.survey-page-list-item--active {\n  background-color: var(--offRed);\n  color: #000;\n}\n\n.survey-page-list-item-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n}\n\n.survey-duration-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.survey-duration-header h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 100%;\n}\n\n.survey-duration-description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n  margin-bottom: 24px;\n}\n\n.survey-cloud-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.survey-cloud-item {\n  margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"survey-header": `styles_survey-header__qpZZD`,
	"survey-title-container": `styles_survey-title-container__6HP9A`,
	"survey-header-btn": `styles_survey-header-btn__0up2b`,
	"survey-header-input": `styles_survey-header-input__OH+pO`,
	"survey-header-info": `styles_survey-header-info__DFDs9`,
	"survey-header-info-item": `styles_survey-header-info-item__+V2Lq`,
	"survey-header-info-status": `styles_survey-header-info-status__xMkks`,
	"survey-header-post": `styles_survey-header-post__sTtb3`,
	"survey-content": `styles_survey-content__52rnO`,
	"survey-navigation": `styles_survey-navigation__j4GnH`,
	"survey-page-list": `styles_survey-page-list__ABt2H`,
	"survey-page-list-item": `styles_survey-page-list-item__0VH6I`,
	"survey-page-list-item--active": `styles_survey-page-list-item--active__D5Nw9`,
	"survey-page-list-item-title": `styles_survey-page-list-item-title__TNh7I`,
	"survey-duration-header": `styles_survey-duration-header__rpGsQ`,
	"survey-duration-description": `styles_survey-duration-description__7i6pK`,
	"survey-cloud-item": `styles_survey-cloud-item__K+QLL`
};
export default ___CSS_LOADER_EXPORT___;
